import {Component, Inject, Input, Output, EventEmitter} from 'ng-metadata/core';
import {JwtUtilService} from "../../../../../security/jwtUtil.service";
import { getResourceType } from '../../../../../infra/ngrsUtil';

@Component({
    "selector": "prm-offer-details-tile",
    templateUrl: 'components/search/fullView/ngrs/getItRequest/offerDetailsTile/offerDetailsTile.html'
})

export class PrmOfferDetailsTile{

    @Input() bestoffer:Object;
    @Input() private isdigitaloffer: boolean;
    @Input() item:Object;
    @Input() private offerinitiallyebook: boolean;
    @Input() private refinebuttonhidden: boolean;
    @Input() private refinebuttonmandatory: boolean;
    @Input() private servicewithnoknownterms: boolean;
    @Input() private refineoffervisible: boolean;
    @Input() private refinebuttondisabled: boolean;
    @Input() private refinebuttoninprogress: boolean;
    @Input() private refinebuttontooltip: string;
    @Input() private refinebuttonlabel: string;

    @Output() private refineOffer = new EventEmitter();

    constructor (@Inject('actionIcons') private actionIcons: Object){
    }

    public onRefineOffer(){
        this.refineOffer.emit('true');
    }

    ngOnInit(){
    }

    public getOfferLoanPeriod(){
        return this.bestoffer? this.bestoffer.loanPeriod : undefined;
    }
    
    public getOfferSupplyTime(){
        return this.bestoffer? this.bestoffer.supplyTime : undefined;
    }
    
    public isUnavailableResource(){
        return this.bestoffer? this.bestoffer.unavailableResource : undefined;
    }
    
    public isDigitalOffer(){
        return this.isdigitaloffer;
    }

    public isNoOfferAfterRefine(){
        return this.bestoffer? this.bestoffer._noOfferAfterRefine : undefined;
    }
    
    public getNoOfferAfterRefineMessage(){
        if (this.bestoffer && this.bestoffer._showPUANoOfferMessage){
            return "nui.ngrs.pickup.information.failedToFindOfferWithPickupInstitution";
        }
        if (this.requestCannotBeSubmitted()) {
            return 'rapido.tiles.noRequestCanBeSubmitted';
        }
        return "rapido.tiles.physical.no_best_offer.line_3"
    }


    private requestCannotBeSubmitted() {

        if (this.refinebuttonhidden) {
            return false;
        }

        if (this.offerinitiallyebook && this.noOfferFound(this.bestoffer)) {
            return true;
        }
        return this.servicewithnoknownterms && this.noOfferFound(this.bestoffer);
    }

    public getResourceType(){
        return getResourceType(this.item);
    }

    public getPatronCost(){
        return this.bestoffer? this.bestoffer.patronCost : undefined;
    }

    public getCurrency(){
        return this.bestoffer? this.bestoffer.currency : undefined;
    }

    public isShowPatronCost(){
        return this.bestoffer? this.bestoffer.hasOwnProperty('patronCost')
            && typeof this.bestoffer.patronCost != "undefined" && typeof this.bestoffer.currency != "undefined" : undefined;
    }

    public isEbookOffer(){
        if (!this.bestoffer == null || !this.bestoffer.ebookOffer){
            return false;
        }
        return this.bestoffer.ebookOffer;
    }

    private noOfferFound(currentOfferDetails) {
        if (!currentOfferDetails) {
            return true;
        }
        // No terms at all - last resort
        return currentOfferDetails.supplyTime === undefined && currentOfferDetails.loanPeriod === undefined;

    }

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/getItRequest/offerDetailsTile/offerDetailsTile.directive.ts